<template>
  <div>
    <b-row>
      <div class="description-box d-flex align-items-center col-3    pl-4">
        <div :class="['nino-mtavruli',{'font-size-for-eng': $t('isgeo') == 0}]">{{$t('signatureaccept')}}</div>
      </div>
      <div class="border-value d-flex align-items-center col-3  text-center p-3">
        <div class="h-center"> <template v-if="showInsurerDetailsInfo==='True'"> Digitally Accepted Date: {{ serverDate }} </template>
         </div>
      </div>
      <div class="description-box  d-flex align-items-center col-3   text-center p-3">
          <div :class="['nino-mtavruli',{'font-size-for-eng': $t('isgeo') == 0}]"> {{$t('signatureinsurer')}}</div>
      </div>
      <div class="border-value d-flex align-items-center col-3  p-2">
        <div class="watermark">
          <div class="d-flex justify-content-between blur">
            <div class="col-6 p-0 company">JSC ARDI INSURANCE</div>
            <div class="col-6 p-0">Digitally signed by JSC ARDI INSURANCE<br/>
              Date: {{ serverDate }}
            </div>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Signature",
  //props:['showInsurerDetails'],
  data() {
    return {
      serverDate: '',
      showInsurerDetailsInfo: this.$route.query.showInsurerDetailsInfo??'True',
    }
  },
  mounted() {
    console.log("sad",this.showInsurerDetailsInfo)
    this.$http.get("/policy/getDate").then((r) => {
      this.serverDate = r.data
    }).catch((e) => {
      console.log(e)
    })
  }
}
</script>

<style scoped>
@import "~bpg-nino-mtavruli";

.nino-mtavruli {
  font-family: "BPG Nino Mtavruli", sans-serif;
  font-size:15px;
}

.company {
  font-size: 13.5pt;
}

.watermark {
  background-size: 100px;
}

.blur {
  background-color: rgba(255, 255, 255, 0.50);
}

.description-box {
  background: #007960;
  color: #ffffff;
}
    @media print {
        .font-size-for-eng {
            font-size: 24px !important;
        }
    }
</style>